export default class WindowUnloadManager {
  #count = 0
  #addReferenceCount() {
    this.#count += 1
  }

  get referenceCount() {
    return this.#count
  }

  #reduceReferenceCount() {
    if (this.#count > 0) {
      this.#count -= 1
    }
  }

  onBeforeUnload() {
    this.#addReferenceCount()
  }

  removeOnBeforeUnload() {
    this.#reduceReferenceCount()
  }
}

const INSTANCE = new WindowUnloadManager()

export { INSTANCE }
